import { render, staticRenderFns } from "./Wp_pdd_order_count_new.vue?vue&type=template&id=48c4c678&scoped=true&"
import script from "./Wp_pdd_order_count_new.vue?vue&type=script&lang=js&"
export * from "./Wp_pdd_order_count_new.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48c4c678",
  null
  
)

export default component.exports